// extracted by mini-css-extract-plugin
module.exports = {"animation":"Badge_animation__7HZ2w","shineDefault":"Badge_shineDefault__tvEwR","shineHover":"Badge_shineHover__a_K0B"};